<template>
  <div class="row">
    <div class="col-xl-12">
      <router-view />
      <div
        v-show="$route.path.toLowerCase() == '/report/stockbarcodesnapshot'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-camera"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">Snapshot Date:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reSnapshotDate"
                      name="reSnapshotDate"
                      ref="reSnapshotDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">BARCODE:</label>
                  <input
                    v-model="reBarcodes"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <button type="submit" class="btn btn-primary">
                    Generate Report
                  </button>
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="resetForm"
                  >
                    ล้างค่าทั้งหมด
                  </button>
                  <button
                    class="btn btn-outline-primary pull-right"
                    @click.prevent="exportExcel"
                    :disabled="isInitial"
                  >
                    <span>
                      <i class="fas fa-file-export"></i><span> Export Excel</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!-- begin: DataTable -->
          <div class="table-responsive">
            <table
              ref="dataTable"
              id="snapshotTable"
              class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
              style="width: 100%;"
            >
              <thead>
                <tr>
                  <th class="all text-right" :colspan="columnCount">
                    ข้อมูล ณ วันที่ {{ reSnapshotDateDisplay }}
                  </th>
                </tr>
                <tr>
                  <th class="all text-center">ลำดับ</th>
                  <th class="all text-center">เจ้าของทรัพย์สิน</th>
                  <th class="all text-center">สถานะ</th>
                  <th class="all text-center">BARCODE</th>
                  <th class="all text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                  <th class="all text-center">ปี(สินค้า)</th>
                  <th class="all text-center">ราคา(สินค้า)</th>
                  <th class="all text-center">รหัสทรัพย์สิน(บัญชี)</th>
                  <th class="all text-center">ประเภทสินค้า</th>
                  <th class="all text-center">รหัสสินค้า</th>
                  <th class="all text-center">ชื่อสินค้า</th>
                  <th class="all text-center">รหัสแบรนด์สินค้า</th>
                  <th class="all text-center">ชื่อแบรนด์สินค้า</th>
                  <th class="all text-center">แบรนด์สินค้า</th>
                  <th class="all text-center">วันที่ผลิตครั้งล่าสุด</th>
                  <th class="all text-center">รหัสผู้ถือครอง</th>
                  <th class="all text-center">ผู้ถือครอง</th>
                  <th class="all text-center">ผู้ถือครอง 2</th>
                  <th class="all text-center">ประเภทผู้ถือครอง</th>
                  <th class="all text-center">ประเภทคงค้าง</th>
                  <th class="all text-center">เขตการขาย(ผู้ถือครอง)</th>
                  <th class="all text-center">จังหวัด(ผู้ถือครอง)</th>
                  <th class="all text-center">ประเภทร้านค้า</th>
                  <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                  <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                  <th class="all text-center">รหัสตัวแทนจำหน่าย(Group)</th>
                  <th class="all text-center">ชื่อตัวแทนจำหน่าย(Group)</th>
                  <th class="all text-center">เขตการขาย(ตัวแทนจำหน่าย)</th>
                  <th class="all text-center">จังหวัด(ตัวแทนจำหน่าย)</th>
                  <th class="all text-center">รหัสตัวแทนจำหน่ายย่อย</th>
                  <th class="all text-center">ชื่อตัวแทนจำหน่ายย่อย</th>
                  <th class="all text-center">จังหวัดตัวแทนจำหน่ายย่อย</th>
                  <th class="all text-center">วันที่ทำรายการล่าสุด</th>
                  <th class="all text-center">ตรวจสอบครั้งล่าสุด</th>
                  <th class="all text-center">ประเภทการตรวจสอบครั้งล่าสุด</th>
                  <th class="all text-center">สถานะการตรวจสอบ</th>
                  <th class="all text-center">ขนส่ง</th>
                  <th class="all text-center">ทะเบียนขนส่ง/ผู้ดำเนินการ</th>
                  <th class="all text-center">จำนวนวันคงค้าง</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
          <!-- end: DataTable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      reSnapshotDate: null,
      reSnapshotDateDisplay: "",
      reBarcodes: "",
      isInitial: true,
      dataTable: null,
      columnCount: 39,
    };
  },
  mounted() {
    this.initDatepicker();
    this.initDataTable();
    this.$nextTick(function () {
      this.setupTopScrollbar();
    });
  },
  methods: {
    initDatepicker() {
      var self = this;
      var arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
      $(self.$refs.reSnapshotDate).datepicker({
        autoclose: true,
        clearBtn: true,
        format: "dd/mm/yyyy",
        rtl: KTUtil.isRTL(),
        endDate: moment().toDate(),
        orientation: "bottom left",
        todayBtn: "linked",
        todayHighlight: true,
        templates: arrows,
      });
      $(self.$refs.reSnapshotDate)
        .datepicker("update", null)
        .on("changeDate", function (e) {
          self.reSnapshotDate = e.dates.length != 0 ? moment(e.date) : null;
        });
    },
    initDataTable() {
      var self = this;
      $.fn.dataTable.ext.errMode = "none";
      self.dataTable = $("#snapshotTable").DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: false,
        serverSide: true,
        searching: false,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/StockBarcodeSnapshot",
          type: "POST",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            d.isInitial = self.isInitial;
            d.snapshotDate = self.reSnapshotDate
              ? self.reSnapshotDate.format("YYYY-MM-DD")
              : "";
            d.barcodes = self.reBarcodes;
            return JSON.stringify(d);
          },
          error: function (xhr, error, thrown) {
            KTApp.unblockPage();
            $('.dataTables_processing').hide();
            var msg = "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง";
            try {
              var resp = JSON.parse(xhr.responseText);
              if (resp && resp.error) msg = resp.error;
            } catch (e) {}
            Swal.fire("เกิดข้อผิดพลาด", msg, "error");
          },
        },
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
              <'row'<'col-sm-12'tr>>
              <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [50, 100, 200, 500],
        pageLength: 100,
        columns: [
          { data: null, className: "text-center", render: function (data, type, row, meta) { return meta.row + meta.settings._iDisplayStart + 1; } },
          { data: "assetOwnerName", className: "text-center" },
          { data: "barcodeStatusName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "departmentMaterialCode", className: "text-center" },
          { data: "barcodeYear", className: "text-center" },
          { data: "unitPrice", className: "text-right" },
          { data: "accountMaterialCode", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "assetCode", className: "text-center" },
          { data: "assetName", className: "text-center" },
          { data: "finishedProductCode", className: "text-center" },
          { data: "finishedProductName", className: "text-center" },
          { data: "brandName", className: "text-center" },
          { data: "finishedProductDate", className: "text-center" },
          { data: "currentLocationCode", className: "text-center" },
          { data: "currentLocationName", className: "text-center" },
          { data: "currentLocationName2", className: "text-center" },
          { data: "currentLocationType", className: "text-center" },
          { data: "ownerTypeCode", className: "text-center" },
          { data: "salesAreaName", className: "text-center" },
          { data: "provinceId", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "hostAgentCode", className: "text-center" },
          { data: "hostAgentName", className: "text-center" },
          { data: "headAgentCode", className: "text-center" },
          { data: "hostAgentDepartment", className: "text-center" },
          { data: "hostAgentSalesAreaId", className: "text-center" },
          { data: "hostAgentProvinceId", className: "text-center" },
          { data: "hostSubAgentCustCode", className: "text-center" },
          { data: "hostSubAgentName", className: "text-center" },
          { data: "hostSubAgentProvinceId", className: "text-center" },
          { data: "latestActiveDate", className: "text-center" },
          { data: "latestActivePMDate", className: "text-center" },
          { data: "latestActiveDateType", className: "text-center" },
          { data: "latestActiveDateStatus", className: "text-center" },
          { data: "transitCompanyName", className: "text-center" },
          { data: "latestCommitUserName", className: "text-center" },
          { data: "onHoldDays", className: "text-center" },
        ],
        order: [[3, "asc"]],
        language: {
          processing: "กำลังโหลด...",
          lengthMenu: "Display _MENU_",
          zeroRecords: "ไม่พบข้อมูล",
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "Showing 0 to 0 of 0 entries",
          infoFiltered: "(filtered from _MAX_ total entries)",
          paginate: { first: "First", last: "Last", next: "Next", previous: "Previous" },
        },
        drawCallback: function () {
          self.isInitial = false;
          if (self.reSnapshotDate) {
            self.reSnapshotDateDisplay = self.reSnapshotDate.format("DD/MM/YYYY");
          }
          self.syncTopScrollbar();
        },
      });

      $("#snapshotTable").on("error.dt", function (e, settings, techNote, message) {
        console.error("DataTable error:", message);
      });
    },
    formSubmit(e) {
      e.preventDefault();
      var self = this;

      if (!self.reSnapshotDate) {
        Swal.fire("กรุณาเลือก Snapshot Date", "", "warning");
        return;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      self.isInitial = false;
      self.dataTable.ajax.reload(function () {
        KTApp.unblockPage();
      });
    },
    resetForm() {
      var self = this;
      self.reBarcodes = "";
      self.reSnapshotDate = null;
      self.reSnapshotDateDisplay = "";
      $(self.$refs.reSnapshotDate).datepicker("update", null);
      self.isInitial = true;
      self.dataTable.ajax.reload();
    },
    exportExcel(e) {
      e.preventDefault();
      var self = this;

      if (!self.reSnapshotDate) {
        Swal.fire("กรุณาเลือก Snapshot Date", "", "warning");
        return;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportStockBarcodeSnapshot",
        responseType: "arraybuffer",
        data: {
          snapshotDate: self.reSnapshotDate.format("YYYY-MM-DD"),
          barcodes: self.reBarcodes,
          isInitial: false,
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
          console.error("Export error:", error);
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
    // Top scrollbar (pattern from QCGroupByAgent)
    setupTopScrollbar() {
      var self = this;
      var scrollBody = document.querySelector("#snapshotTable_wrapper .dataTables_scrollBody");
      var scrollHead = document.querySelector("#snapshotTable_wrapper .dataTables_scrollHead");
      if (!scrollBody || !scrollHead) return;

      var topScroll = document.createElement("div");
      topScroll.id = "snapshotTopScrollbar";
      topScroll.style.cssText = "overflow-x: auto; overflow-y: hidden; height: 20px; margin-bottom: -1px;";
      var inner = document.createElement("div");
      inner.id = "snapshotTopScrollbarInner";
      inner.style.cssText = "height: 1px;";
      topScroll.appendChild(inner);

      scrollHead.parentNode.insertBefore(topScroll, scrollHead);

      var syncing = false;
      topScroll.addEventListener("scroll", function () {
        if (syncing) { syncing = false; return; }
        syncing = true;
        scrollBody.scrollLeft = topScroll.scrollLeft;
      });
      scrollBody.addEventListener("scroll", function () {
        if (syncing) { syncing = false; return; }
        syncing = true;
        topScroll.scrollLeft = scrollBody.scrollLeft;
      });
      self.syncTopScrollbar();
    },
    syncTopScrollbar() {
      this.$nextTick(function () {
        var scrollBody = document.querySelector("#snapshotTable_wrapper .dataTables_scrollBody");
        var inner = document.getElementById("snapshotTopScrollbarInner");
        if (!scrollBody || !inner) return;
        inner.style.width = scrollBody.scrollWidth + "px";
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Report/StockBarcodeSnapshot.vue